import * as React from "react"
import { User } from "@/models/user";
import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useReducer,
  useState,
} from "react";
import { useAuthContext } from "./authContext";
import { AppContext } from "@/models/context";
import { mainReducer } from "./mainReducer";
import { ACTIONS } from "./actions";


export interface ApplicationContextProps  {
  mainState?: AppContext ;
  setUser: (user: User) => void;
	setLoading: (isLoading: boolean) => void;
  setReload: (showReload: boolean) => void;
  setButton: (currentButton:number) => void;
};

export const MainContext = createContext<ApplicationContextProps>({} as ApplicationContextProps );

export default function MainContextProvider({ children, }: { children: ReactNode;}) {
	const INITIAL_STATE:AppContext = {
		user:{user_id:0},
		// El cargador no debe cubrir la aplicación al iniciar. Solo se activa
		// temporalmente desde ProtectedLayout mientras se consulta el usuario.
		isLoading:false,
    showReload:true
	}
	
	const [mainState, dispatch] = useReducer(mainReducer,INITIAL_STATE);

	const setUser = useCallback((user:User) =>{
		dispatch({ type: ACTIONS.SET_USER, payload: { user } });
  }, []);

	const setLoading = useCallback((isLoading: boolean) =>{
		dispatch({ type: ACTIONS.SET_LOADING, payload: { isLoading } });
  }, []);

  const setReload = useCallback((showReload: boolean) =>{
		dispatch({ type: ACTIONS.SET_RELOAD, payload: {showReload } });
  }, []);

  const setButton = useCallback((currentButton: number) =>{
		dispatch({ type: ACTIONS.SET_BUTTON, payload: { currentButton } });
  }, []);

	
	const value = useMemo(
    () => ({
      setUser,
			setLoading,
      setButton,
      setReload,
			mainState,
    }),
    [mainState,setUser,setLoading,setButton,setReload]
  );

  return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
}

export function  useMainContext() {
  return useContext(MainContext);
}
